import React from 'react';
import { CircleHelp } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/ui/tooltip';

const PaidOperationsSummary = ({ operations, help = null, baseLabel = 'pèlerins soldés' }) => {
  const rows = [
    ['Pèlerins aptes', operations.medically_fit],
    ['Passeports déposés', operations.passport_deposited],
  ];

  return (
    <>
      <div className="-mt-2 mb-4 flex items-center gap-2 text-[13px] text-slate-500">
        Base : {operations.base.toLocaleString('fr-FR')} {baseLabel}
        {help && (
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                type="button"
                aria-label="Définition de la base opérationnelle"
                className="rounded-full focus-visible:outline focus-visible:outline-2"
              >
                <CircleHelp className="h-4 w-4" />
              </button>
            </TooltipTrigger>
            <TooltipContent>{help}</TooltipContent>
          </Tooltip>
        )}
      </div>
      <div className="space-y-3">
        {rows.map(([label, value]) => (
          <div key={label}>
            <div className="mb-1.5 flex justify-between gap-2 text-sm">
              <span>{label}</span>
              <strong className="text-xs">
                {value.toLocaleString('fr-FR')} / {operations.base.toLocaleString('fr-FR')}
              </strong>
            </div>
            <div className="h-1.5 overflow-hidden rounded-sm bg-slate-100" aria-hidden="true">
              <div
                className="h-full bg-emerald-600"
                style={{ width: `${operations.base ? (value / operations.base) * 100 : 0}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default PaidOperationsSummary;
